"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var msal_1 = require("msal");

var AzureAuthService =
/** @class */
function () {
  function AzureAuthService(config, redirectCallback) {
    var _this = this;

    this.config = config;
    this.redirectCallback = redirectCallback;

    this.isForgotPasswordError = function (error) {
      return error && error.errorMessage && error.errorMessage.includes('AADB2C90118');
    };

    this.isInternalError = function (error) {
      return error && error.errorMessage && error.errorMessage.includes('AADB2C90273');
    };
    /*
    This is a workaround due to the msal library not supporting multiple policies at this time.
    The work to support multiple policies for b2c in MSAL is tracked here
    TODO: Update this implementation using updated msal library when this issue is resolved: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/440
     */


    this.passwordResetRedirect = function () {
      if (!_this.config.passwordResetUrl) {
        console.warn("No password reset url configured to handle forgot password error.");
        return;
      }

      window.location.href = _this.config.passwordResetUrl;
    };
    /*
    This is a workaround to allow multiple ADP client apps to authenticate.
    On a internal_error response from ADP, we switch Providers using the domain_hint
    query param and try to authenticate again.  At this point the user would already be
    authenticated with ADP so if they have the app linked with the client id it will return successfully.
    */


    this.optionalDomainHintRedirect = function (state) {
      if (!_this.config.domainHints || _this.config.domainHints.length === 0) {
        console.info("No domain hints have been configured.");
        return;
      }

      console.log(state);
      var domainHintIndex = 0;

      if ('domainHint' in state) {
        var domainHint = state.domainHint;
        domainHintIndex = _this.config.domainHints.indexOf(domainHint);
        ++domainHintIndex;

        if (domainHintIndex >= _this.config.domainHints.length) {
          console.info("Max domain hints have been used.");
          return;
        }
      }

      var domain_hint = _this.config.domainHints[domainHintIndex];

      if (state) {
        state.domainHint = domain_hint;
      } else {
        state = {
          domainHint: domain_hint
        };
      }

      console.warn("Redirecting to login with marketing domain_hint: " + domain_hint);
      var request = {
        extraQueryParameters: {
          domain_hint: domain_hint
        },
        scopes: _this.config.scopes,
        state: JSON.stringify(state)
      };

      _this._app.loginRedirect(request);
    };

    this.logout = function () {
      return _this._app.logout();
    }; // The compiler requires the type be asserted as unknown before being asserted to an incompatible type


    this.login = function (state) {
      return _this._app.loginPopup({
        scopes: _this.config.scopes,
        state: state
      });
    };

    this.loginRedirect = function (state) {
      _this._app.loginRedirect({
        scopes: _this.config.scopes,
        state: state ? JSON.stringify(state) : undefined
      });
    };

    this.loginRedirectImpersonation = function (state, objectId) {
      var request = {
        authority: 'https://gsbdirectory.b2clogin.com/tfp/gsbdirectory.onmicrosoft.com/B2C_1A_signin_impersonation',
        scopes: _this.config.scopes,
        redirectUri: window.location.origin + "/oauth2/callback"
      };

      if (state) {
        request.state = JSON.stringify(state);
      }

      if (objectId) {
        request.extraQueryParameters = {
          objectId: objectId
        };
      }

      _this._app.loginRedirect(request);
    }; // Setting the scope to the clientID indicates to MSAL we are interested in an ID token not an Access tokens
    // MSAL will throw an error if you try and add any additional scopes when you include client ID.


    this.getToken = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              request = {
                scopes: [this._app.getCurrentConfiguration().auth.clientId],
                authority: this.config.authorityUrl
              };
              return [4
              /*yield*/
              , this._app.acquireTokenSilent(request)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];
          }
        });
      });
    };

    this.isAuthenticated = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var token, _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , this.getToken()];

            case 1:
              token = _b.sent();
              return [2
              /*return*/
              , !!token];

            case 2:
              _a = _b.sent();
              return [2
              /*return*/
              , false];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    }; // Required to prevent an auth loop on IE / Edge
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issues-on-IE-and-Edge-Browser#1-issues-due-to-security-zones


    var storeAuthStateInCookie = function (userAgent) {
      var msie = userAgent.indexOf('MSIE ') > 0;
      var msie11 = userAgent.indexOf('Trident/') > 0;
      var msedge = userAgent.indexOf('Edge/') > 0;
      var isIE = msie || msie11 || msedge;
      return isIE;
    }(window.navigator.userAgent);

    var msalConfig = {
      auth: {
        clientId: this.config.clientId,
        authority: this.config.authorityUrl,
        redirectUri: this.config.redirectUri,
        navigateToLoginRequestUrl: false,
        postLogoutRedirectUri: this.config.postLogoutRedirectUri,
        // Azure AD B2C requires validate authority to be set to false
        // https://docs.microsoft.com/en-us/azure/active-directory-b2c/b2clogin
        validateAuthority: false
      },
      cache: {
        // Local storage cache enables SSO between tabs
        // https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-sso
        cacheLocation: "localStorage",
        storeAuthStateInCookie: storeAuthStateInCookie
      }
    };
    this._app = new msal_1.UserAgentApplication(msalConfig);

    this._app.handleRedirectCallback(function (err, res) {
      if (_this.isForgotPasswordError(err)) {
        _this.passwordResetRedirect();
      }

      if (_this.isInternalError(err)) {
        // ADP Round Robin
        _this.optionalDomainHintRedirect((res === null || res === void 0 ? void 0 : res.accountState) ? JSON.parse(res.accountState) : {});
      }

      _this.redirectCallback(err, res);
    });
  }

  return AzureAuthService;
}();

exports.AzureAuthService = AzureAuthService;